import { render } from "./TravelPassEntryList.vue?vue&type=template&id=0c25998e&lang=pug"
import script from "./TravelPassEntryList.vue?vue&type=script&lang=ts"
export * from "./TravelPassEntryList.vue?vue&type=script&lang=ts"

import "./TravelPassEntryList.vue?vue&type=style&index=0&id=0c25998e&lang=scss"
script.render = render

export default script